import request from '@/api/req/request'
import logins from '@/api/req/login'

/**
 * 登录
 */
export function login(mobile,password) {
  return logins.post('/index/user/login',{
      mobile: mobile,
      password: password
  })
}

/** DD登录 */
export function ddTalkLogin(code) {
  return request.get('/index/Dingtalk/loginByDingDing',{
    params: {
      code
    }
  })
}

/* 注册*/
export function register(i) {
  return logins.post('/index/user/join',{
      ...i
  })
}

/**获取验证码*/
export function getPin(mobile) {
  return logins.post('/index/user/sendCode',{
      mobile: mobile
  })
}

/**密码修改*/
export function changePwdApi(data) {
  return logins.post('/index/user/changePwd',data)
}

/**密码登录*/
export function pwloginApi(data) {
  return logins.post('/index/user/pwlogin',data)
}

/**获取个人信息*/
export function getUserInfo() {
  return request.post('/index/user/getUserInfo',{
  })
}

/**获取标签*/
export function getTag() {
  return request.post('/index/user/getTags',{
  })
}

/**编辑个人信息*/
export function editUser(user) {
  return request.post('/index/user/editUser',{
    ...user
  })
}

/**获取奖金明细*/
export function getMoneyh(page) {
  return request.get('/index/task/getAwordLog',{
    params: {
      page,
      limit: 4
    }
  })
}

/**获取身份证图片*/
export function getIdcard() {
  return request.get('/index/user/showIdcard',{
    params: {
    }
  })
}

/**获取银行列表*/
export function getBank(page,title, limit) {
  return request.get('/index/user/getBanks',{
    params: {
      page,
      title,
      limit
    }
  })
}

/**获取支行列表*/
export function getBranch(page, bank ,title, limit) {
  return request.get('/index/user/getBanksSecond',{
    params: {
      page,
      bank,
      title,
      limit
    }
  })
}

/**数据查看*/
export function statisticsDataApi(month ) {
  return request({
    url:'/index/V2.task/statisticsData?month='+ month ,
    method:'GET'
  })
}